import { Box, CircularProgress, Stack, Typography, styled } from '@mui/material';
import { CO2Icon, SmileIcon } from 'src/theme/overrides/CustomIcons';

import { formatNumber } from 'src/utils/numberFormatter';

// ----------------------------------------------------------------------

const StyledGenericImpactMetric = styled(Stack)(({ theme }) => ({
  flexWrap: 'wrap',
  '& .MuiTypography-root': {
    margin: theme.spacing(0),
  },
  '& .primary': {
    color: theme?.palette?.branded?.pink,
    '& span': {
      color: theme?.palette?.branded?.pink,
    },
  },
  '& .secondary': {
    color: theme?.palette?.branded?.darkGreenContentment,
    '& span': {
      color: theme?.palette?.branded?.darkGreenContentment,
    },
  },
  '& .impact': {
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
  '& span': {
    fontSize: 10,
  },
}));

const config: { [key: string]: JSX.Element } = {
  CONTRIBUTIONS: <SmileIcon sx={{ width: 43, height: 30 }} />,
  CARBON: <CO2Icon sx={{ width: 62, height: 30 }} />,
};

const ImpactTile: React.FC<any> = ({ item, size, loading }) => {
  return (
    <Stack spacing={2}>
      <Stack gap={1} direction={'row'} alignItems={'flex-end'} className='impact'>
        {item?.key && <Box sx={{ '& svg': {  } }}>{config[item?.key]}</Box>}
        <Box>
          {loading ? (
            <CircularProgress size={12} />
          ) : (
            <Typography variant={size === 'large' ? 'h3' : 'h4'}>
              {item?.data?.value && formatNumber(item?.data?.value)}{' '}
              {item?.data?.unit?.toLowerCase()}
            </Typography>
          )}
        </Box>
      </Stack>
      <Typography variant="ticker1Label">{item.title}</Typography>
    </Stack>
  );
};

const GenericImpactMetric: React.FC<any> = ({ items, size, loading, sx }) => {
  return (
    <StyledGenericImpactMetric direction={'row'} gap={{ xs: 3, sm: 6 }} sx={{ ...sx }}>
      {items?.map((item: any, idx: number) => {
        return (
          <Stack
            key={idx}
            className={'impact ' + item?.className}
            direction={'row'}
            gap={1}
          >
            <ImpactTile item={item} size={size} loading={loading} />
          </Stack>
        );
      })}
    </StyledGenericImpactMetric>
  );
};

export default GenericImpactMetric;
